<!-- 戻るボタン -->
<div class="mb-3">
  <button
    pButton
    type="button"
    (click)="goBack()"
    class="p-button-text p-button-sm">
    <i
      class="pi pi-arrow-left"
      aria-hidden="true"></i>
    戻る
  </button>
</div>

<!-- 閉じたら配列から外す。track を $index にすると、閉じて非表示になった p-message が次のメッセージに使い回される -->
@for (m of messages; track m) {
  <p-message
    [severity]="m.severity"
    [closable]="true"
    (onClose)="messages.splice($index, 1)"
    class="mb-3">
    <b>{{ m.summary }}</b>
    {{ m.detail }}
  </p-message>
}

<p-panel
  header="Amazon通知 - 手動登録"
  [toggleable]="false">
  <div class="grid">
    <div class="col-12">
      <p class="mb-3">
        Amazon通知を受け取りたい商品のASINを改行区切りで入力してください。
        <br />
        ASINは10文字の英数字（例：B08N5WRWNW）です。
      </p>

      <div class="field">
        <label for="asin-input">ASIN一覧</label>
        <textarea
          id="asin-input"
          pInputTextarea
          [(ngModel)]="asinInput"
          rows="10"
          cols="30"
          placeholder="B08N5WRWNW&#10;B07XJ8C8F5&#10;B09KMVNY9J"
          class="w-full"
          [disabled]="isLoading"></textarea>
        <small class="p-text-secondary">1行に1つのASINを入力してください。重複は自動的に除去されます。</small>
      </div>

      <div class="flex gap-2 mt-3">
        <button
          pButton
          type="button"
          [loading]="isLoading"
          (click)="onSubmit()"
          class="p-button-success">
          <i
            [class]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            aria-hidden="true"></i>
          登録
        </button>

        <button
          pButton
          type="button"
          (click)="onClear()"
          [disabled]="isLoading"
          class="p-button-secondary">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
          クリア
        </button>
      </div>
    </div>
  </div>
</p-panel>
